import { Box, Typography } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { rgba } from "polished";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  headerChecklist: {
    backgroundColor: rgba(255, 255, 255, 0.1),
    borderTop: '2px solid #3E4345',
    borderBottom: '1px solid #3E4345',
    color: '#919699',
    height: "48px",
    paddingLeft: "18px",
    justifyContent: "flex-start",
    flexDirection: "row",
    width: "100%",
  },
  h1Checklist: {
    height: "90%",
    width: "100%",
    display: "flex",
    alignItems: "center",
  },
  plug: {
    width: '50px'
  },
  columnListPoints: {
    width: '54%',
    color: 'rgba(252, 243, 215, 1)'
  },
  columnStatus: {
    width: '12%',
    minWidth: '100px',
    display: 'flex',
    justifyContent: 'center'
  },
  columnUser: {
    width: '12%',
    display: 'flex',
    justifyContent: 'center'
  },
  columnPriority: {
    width: '10%',
    minWidth: '94px',
    display: 'flex',
    justifyContent: 'center'
  },
  columnLastUpdate: {
    width: '12%',
    display: 'flex',
    justifyContent: 'center'
  },
})

const ChecklistHeader = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <div className={classes.headerChecklist}>
      <h1 className={classes.h1Checklist}>
        <Box className={classes.columnListPoints}>
          <Typography>{t('CLP_List_points')}</Typography>
        </Box>
        <Box className={classes.columnPriority}>
          <Typography>{t('CLP_Priority')}</Typography>
        </Box>
        <Box className={classes.columnUser}>
          <Typography>{t('CLP_User')}</Typography>
        </Box>
        <Box className={classes.columnStatus}>
          <Typography>{t('CLP_Status')}</Typography>
        </Box>
        <Box className={classes.columnLastUpdate}>
          <Typography>{t('CLP_lastUpdate')}</Typography>
        </Box>
        <div className={classes.plug}/>
      </h1>
    </div>
  )
}

export default ChecklistHeader
